import { getTheme, Stack, Text } from "@fluentui/react";

import { lineAdditionalServiceTypeLabels } from "../../constants";
import { LineAdditionalServiceType } from "../../interfaces";

interface LineAdditionalServiceSummaryProps {
  serviceType: LineAdditionalServiceType;
  quantityLabel: string;
  paymentLabel: string;
  valueLabel: string;
  valueInCents: number;
}

export function LineAdditionalServiceSummary({
  serviceType,
  quantityLabel,
  paymentLabel,
  valueLabel,
  valueInCents
}: LineAdditionalServiceSummaryProps): JSX.Element {
  const theme = getTheme();

  return (
    <section
      style={{
        backgroundColor: theme.palette.themeLighterAlt,
        border: `1px solid ${theme.palette.themeLight}`,
        borderRadius: 6,
        padding: 16
      }}
    >
      <Stack tokens={{ childrenGap: 12 }}>
        <Text variant="mediumPlus" styles={{ root: { fontWeight: 700 } }}>
          Resumo da solicitação
        </Text>

        <Stack tokens={{ childrenGap: 4 }}>
          <Text variant="small">Serviço</Text>
          <Text styles={{ root: { fontWeight: 600 } }}>
            {lineAdditionalServiceTypeLabels[serviceType]}
          </Text>
        </Stack>

        <Stack horizontal horizontalAlign="space-between" wrap>
          <Stack tokens={{ childrenGap: 4 }}>
            <Text variant="small">Quantidade</Text>
            <Text styles={{ root: { fontWeight: 600 } }}>{quantityLabel}</Text>
          </Stack>
          <Stack tokens={{ childrenGap: 4 }} horizontalAlign="end">
            <Text variant="small">Pagamento</Text>
            <Text styles={{ root: { fontWeight: 600 } }}>{paymentLabel}</Text>
          </Stack>
        </Stack>

        <div
          style={{
            backgroundColor: "white",
            borderRadius: 6,
            padding: "14px 16px"
          }}
        >
          <Text variant="small">Valor do serviço</Text>
          <Text
            block
            styles={{
              root: {
                color:
                  valueInCents > 0
                    ? theme.palette.themePrimary
                    : theme.palette.green,
                fontSize: 30,
                fontWeight: 700,
                lineHeight: "38px"
              }
            }}
          >
            {valueLabel}
          </Text>
        </div>
      </Stack>
    </section>
  );
}
